import script from "./SliderThumbnails.vue?vue&type=script&setup=true&lang=js"
export * from "./SliderThumbnails.vue?vue&type=script&setup=true&lang=js"

import "./SliderThumbnails.vue?vue&type=style&index=0&id=bd37900a&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bd37900a"]])

export default __exports__